const InvestorAccountStageStatusEnum = Object.freeze({
    COMPLETE: 'COMPLETE',
    INCOMPLETE: 'INCOMPLETE',
    WARNING: 'WARNING',
    ERROR: 'ERROR'
});

export default InvestorAccountStageStatusEnum;
